import React from 'react';
import { withIcon, SvgIconProps } from '../../../../components/withIcon';
const SvgClockHistoryOutlined = ({ size, title = 'ClockHistoryOutlined', ...props }: SvgIconProps): JSX.Element => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        width={size}
        height={size}
        data-icon-name={title}
        aria-label={title}
        role="presentation"
        {...props}
    >
        <g
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            clipPath="url(#clock-history-outlined_svg__clock-history-outlined_svg__a)"
        >
            <path d="M2.02 9.162l2.625 4.644L8.199 9.79M6 16.6a7.5 7.5 0 10-1.348-2.802" />
            <path d="M12 9v3l3.5 2" />
        </g>
        <defs>
            <clipPath id="clock-history-outlined_svg__clock-history-outlined_svg__a">
                <path fill="currentColor" d="M0 0h24v24H0z" />
            </clipPath>
        </defs>
    </svg>
);
export default withIcon(SvgClockHistoryOutlined);
